import React from "react";
import {Box, Colors} from "@bounce/shared/ui";

type Option<T extends string> = {value: T; label: React.ReactNode; ariaLabel?: string};

type Props<T extends string> = {
  value: T;
  options: Option<T>[];
  onChange: (value: T) => void;
  disabled?: boolean;
};

const SegmentedToggle = <T extends string>({value, options, onChange, disabled = false}: Props<T>) => (
  <Box
    sx={{
      display: "inline-flex",
      flexShrink: 0,
      border: `1px solid ${Colors.tertiary._300}`,
      borderRadius: "8px",
      overflow: "hidden",
      opacity: disabled ? 0.5 : 1,
    }}
  >
    {options.map((option, index) => {
      const selected = option.value === value;
      return (
        <Box
          key={option.value}
          component="button"
          type="button"
          aria-label={option.ariaLabel}
          disabled={disabled}
          onClick={() => onChange(option.value)}
          sx={{
            height: 32,
            px: 1.5,
            display: "inline-flex",
            alignItems: "center",
            border: 0,
            borderLeft: index === 0 ? 0 : `1px solid ${Colors.tertiary._300}`,
            backgroundColor: selected ? Colors.bw.white : Colors.tertiary._200,
            color: selected ? Colors.grey._900 : Colors.grey._600,
            fontFamily: "inherit",
            fontSize: 13,
            fontWeight: selected ? 600 : 500,
            whiteSpace: "nowrap",
            cursor: disabled ? "default" : "pointer",
          }}
        >
          {option.label}
        </Box>
      );
    })}
  </Box>
);

export default SegmentedToggle;
